import { useEffect } from 'react';
import { AppState } from 'react-native';
import { recordSessionOnce } from '../services/session';

/**
 * Enregistre l'ouverture de l'app pour les KPI de rétention : au montage (app ouverte) et à chaque
 * retour au premier plan (AppState 'active'). Débounce 1/jour côté service. Actif seulement connecté.
 */
export function useSessionPing(hasSession: boolean) {
  useEffect(() => {
    if (!hasSession) return;
    void recordSessionOnce(); // ouverture
    const sub = AppState.addEventListener('change', (state) => {
      if (state === 'active') void recordSessionOnce();
    });
    return () => sub.remove();
  }, [hasSession]);
}
